import React from "react";

const HSectionHeader = ({ title, actionLabel, onActionClick }) => {
  return (
    <div className="mb-4 flex items-center justify-between">
      <h2 className="text-xl font-bold">{title}</h2>
      <div className="flex items-center gap-2">
        <button
          className="flex items-center gap-1 rounded-full border border-gray-300 px-3 py-1 text-sm text-gray-600"
          onClick={onActionClick}
        >
          <img src="/img/svgs/plus.svg" alt="Add" className="w-4 h-4" />
          <span>{actionLabel}</span>
        </button>
        <button className="rounded-full p-1 hover:bg-gray-100">
          <img src="/img/svgs/short_left.svg" alt="View more" className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
};

export default HSectionHeader;
